<script>
import baseList from "@/views/components/base/baseList.vue";
import { Tag, Button } from "view-design";

export default {
  extends: baseList,
  components: {},
  data() {
    return {
      table: {
        mname: "configure",
        key: "configId",
        url: {
          del: "/admin/system/config",
        },
        output: false,
      },
      actions: [
        {
          label: "新增",
          icon: "md-add",
          type: "info",
          onClick: this.toAdd,
          auth: "admin/configure/add",
        },
      ],
      menus: [
        // {
        //   label: "配置列表",
        //   name: "configure_list",
        //   auth: "/admin/configure/lists",
        // },
        // {
        //   label: "坐席列表",
        //   name: "callConfig_list",
        //   auth: "/admin/callConfig/lists",
        // },
        // {
        //   label: "公告列表",
        //   name: "notice_list",
        //   auth: "/admin/configure/lists",
        // },
        // {
        //   label: "操作日志",
        //   name: "operlog_list",
        //   auth: "/admin/operlog/lists",
        // },
        // {
        //   label: "登录日志",
        //   name: "logininfor_list",
        //   auth: "/admin/logininfor/lists",
        // },

        // {
        //   label: "投诉管理",
        //   name: "feedback_list",
        //   auth: "/admin/feedback/lists",
        // },
      ],
      filters: [
        {
          label: "配置名称",
          name: "configName",
          value: "",
          KeyEnter: this.search,
          type: "input",
        },
      ],
      tableCols: [
        {
          title: "序号",
          type: "index",
          width: 80,
          align: "center",
        },
        {
          title: "配置名称",
          key: "configName",
          minWidth: 120,
          align: "left",
        },
        {
          title: "键值",
          key: "configKey",
          minWidth: 120,
          align: "left",
        },
        // {
        //   title: '配置内容',
        //   key: 'configValue',
        //   minWidth: 120,
        //   align: 'left',
        // },
        {
          title: "配置内容",
          key: "configValue",
          width: 150,
          align: "left",
          render: (h, params) => {
            return h("div", [
              h(
                "span",
                {
                  style: {
                    display: "inline-block",
                    width: "100%",
                    overflow: "hidden",
                    textOverflow: "ellipsis",
                    whiteSpace: "nowrap",
                  },
                  domProps: {
                    title: params.row.configValue,
                  },
                },
                params.row.configValue
              ),
            ]);
          },
        },
        {
          title: "备注",
          key: "remark",
          width: 150,
          align: "left",
          render: (h, params) => {
            return h("div", [
              h(
                "span",
                {
                  style: {
                    display: "inline-block",
                    width: "100%",
                    overflow: "hidden",
                    textOverflow: "ellipsis",
                    whiteSpace: "nowrap",
                  },
                  domProps: {
                    title: params.row.remark,
                  },
                },
                params.row.remark
              ),
            ]);
          },
        },
        {
          title: "系统内置",
          key: "configType",
          minWidth: 100,
          align: "center",
          render: (h, params) => {
            const row = params.row;
            const text =
              row.configType == "Y" ? "是" : row.configType == "N" ? "否" : "";
            return <span style={{ "font-size": "14px" }}>{text}</span>;
          },
        },
        {
          title: "创建时间",
          width: 150,
          align: "center",
          key: "createTime",
          render: (h, params) => {
            const row = params.row;
            const text = row.createTime.slice(0, 16);
            return <span>{text}</span>;
          },
        },
        {
          title: "操作",
          align: "center",
          width: 160,
          key: "handle",
          handle: [
            "edit",
            // 'delete'
          ],
          auth: {
            edit: "admin/configure/edit",
          },
        },
      ],
    };
  },
  created() {},
  methods: {
    toAdd() {
      $utils.url.push({ name: "configure_add", query: { action: "add" } });
    },
    handleEdit(currentRow) {
      $utils.url.push({
        name: "configure_edit",
        query: { action: "edit", kv: currentRow.configId },
      });
    },
    //转单
    // toChange(row) {},
    //详情
    // toInfo(row) {
    //   $utils.url.push({
    //     name: 'knowledgeBase_info',
    //     query: { action: 'edit', kv: row.id },
    //   })
    // },
    //导出
    toImport() {},
    //下载模板
    toDownload() {},
  },
};
</script>
<style scoped></style>
